import { render, staticRenderFns } from "./ContentToggle.vue?vue&type=template&id=a2f4a3f2&"
import script from "./ContentToggle.vue?vue&type=script&lang=js&"
export * from "./ContentToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports